import { AxiosInstance } from "axios"
import {
    CustomerOption,
    ManageBookingsDryRunResponse,
    ManageBookingsExecuteResponse,
    ManageBookingsRequest,
    UserOption,
} from "./manageBookingsTypes"

export enum ManageBookingsQuery {
    COMPANIES = "manage-bookings-companies",
    USERS_FOR_COMPANY = "manage-bookings-users-for-company",
}

export type CompaniesResponse = Readonly<{
    customers: CustomerOption[]
}>

export type UsersForCompanyResponse = Readonly<{
    users: UserOption[]
}>

type FetchCompaniesParams = Readonly<{
    serviceCenterId: number
}>

type FetchUsersForCompanyParams = Readonly<{
    serviceCenterId: number
    companyId: number
    userGroupId?: number
}>

export async function fetchCompanies(
    { serviceCenterId }: FetchCompaniesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CompaniesResponse> {
    const { data } = await axios.get(`/serviceCenters/${serviceCenterId}/companies`, { signal })
    return data
}

export async function fetchUsersForCompany(
    { serviceCenterId, companyId, userGroupId }: FetchUsersForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<UsersForCompanyResponse> {
    const { data } = await axios.get(`/serviceCenters/${serviceCenterId}/companies/${companyId}/users`, {
        signal,
        params: {
            userGroupId,
        },
    })
    return data
}

export async function manageBookingsForUser(
    { serviceCenterId, orderOperation }: ManageBookingsRequest,
    axios: AxiosInstance,
): Promise<ManageBookingsDryRunResponse | ManageBookingsExecuteResponse> {
    const { data } = await axios.post(`/serviceCenter/${serviceCenterId}/orders/meetingService/upcoming/operation`, {
        orderOperation,
    })
    return data
}
